import { defineComponent as _defineComponent } from 'vue'
import { reactive } from 'vue-demi';
import { useGridItem } from './useGrid';

interface Props {
  width?: number | string;
  height?: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbGridItem',
  props: {
    width: { default: 12 },
    height: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { width: number | string, height: number | string };



const { gridItemStyles } = useGridItem(
  reactive({
    width: props.width,
    height: props.height,
  })
);

return { __sfc: true,props, gridItemStyles }
}

})